import { Reveal, SectionHeading } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function ValueCards() {
  const { t } = useLanguage();
  const CARDS = [
    { img: "/assets/card-ent.webp", alt: "线上数字娱乐大厅界面", title: t("v1Title") },
    { img: "/assets/card-sports.webp", alt: "足球场上的足球", title: t("v2Title") },
    { img: "/assets/card-basketball.webp", alt: "篮球运动员突破瞬间", title: t("v3Title") },
    { img: "/assets/card-esports.webp", alt: "电竞设备", title: t("v4Title") },
  ];
  return (
    <section data-testid="value-cards-section" className="py-5">
      <div className="px-6">
        <SectionHeading index="01" eyebrow="Highlights" title={t("valueHeading")} testId="value-cards-heading" />
      </div>
      <div data-testid="value-cards-track" className="grid grid-cols-2 gap-3 px-6 pb-1">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.06}>
            <article
              data-testid={`value-card-${i + 1}`}
              className="overflow-hidden rounded-2xl border border-[rgba(22,99,230,0.12)] bg-white shadow-[0_10px_28px_-16px_rgba(11,61,145,0.3)] transition-transform duration-300 hover:-translate-y-0.5"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={c.img}
                  alt={c.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-white/90 px-2 py-0.5 text-[10px] font-semibold tracking-wide text-[#0B3D91] backdrop-blur-sm">
                  {c.title}
                </span>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
